import React, { useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { IChannel } from "../../../../services/api/Channel";
import { ICountryCloseupTableContent } from "../CountryCloseup";

am4core.useTheme(am4themes_animated);

interface StackProps {
  id: string;
  data: object[];
  channels: IChannel[];
  totals: ICountryCloseupTableContent;
  isYTD: boolean;
}

const Stack: React.FC<StackProps> = ({ id, data, channels, totals, isYTD }) => {
  // const chart = useRef(null);

  useLayoutEffect(() => {
    let x = am4core.create(id, am4charts.XYChart);
    x.hiddenState.properties.opacity = 0;
    x.background.visible = false;
    x.language.locale["_decimalSeparator"] = ",";
    x.language.locale["_thousandSeparator"] = ".";

    
    // Add data
    x.data = data;
    x.data = x.data.map(item => {
      switch (item.category) {
        case "ACT":
          item.total = isYTD ? totals.tsValueYTD : totals.tsValue;
          break;
        case "LY":
          item.total = isYTD ? totals.valueBaseLYYTD : totals.valueBaseLY;
          break;
        default:
          item.total = isYTD ? totals.valueBaseYTD : totals.valueBase;
          break;
      }

      return item;
    })

    channels.forEach(channel => {
      x.colors.list.push(am4core.color(channel.color));
    });

    x.padding(30, 30, 10, 30);

    // Create axes
    var categoryAxis = x.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.grid.template.opacity = 0;
    categoryAxis.renderer.labels.template.fill = am4core.color("#00162b");
    //categoryAxis.renderer.labels.template.fontSize = 16;

    var valueAxis = x.xAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.strictMinMax = true;
    valueAxis.calculateTotals = true;
    valueAxis.renderer.minWidth = 50;
    valueAxis.renderer.labels.template.fill = am4core.color("#00162b");
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.baseGrid.disabled = true;
    // This adapter adds custom text to the label
    valueAxis.renderer.labels.template.adapter.add(
      "text",
      (label, target, key) => {
        return "";
      }
    );

    function createSeries(field: any, name: any) {
      var series = x.series.push(new am4charts.ColumnSeries());
    
      // Atualizando tooltip para remover totalPercent e adicionar outro valor (exemplo: "extraValue")
      series.columns.template.tooltipText =
        "{name}: {valueX.formatNumber('#,###.')} - TOTAL: {total.formatNumber('#,###.')}";
      series.dataFields.valueX = field;
      series.dataFields.categoryY = "category";
      series.dataFields.valueXShow = "totalPercent";
      series.stacked = true;
      series.name = name;
      series.calculatePercent = true;
    
      var labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.locationX = 0.5;
      //labelBullet.label.text = "{valueX.formatNumber('#,###.')}";
      labelBullet.label.fill = am4core.color("#fff");
    
    }
    

    channels.forEach( channel => createSeries(channel.channelName, channel.channelName));

    // const segmentChannels = ["A, B & C+", "C Universe", "Events", "Key Account"];
    // const sourceChannels = ["Cross Channel", "Hybrid DPs", "ABI Ambev", "Direct", "ONP DPs"];
    // const keyAccountChannels = ["Catering", "QSR", "Fast Casual", "Casual Dining", "CTB", "Lodging", "Recreation", "Travel", "Bar/Pub", "Dancing Pub", "Casino", "Others"];

    // switch (channelType) {
    //   case "segment":
    //     segmentChannels.forEach(channelName => createSeries(channelName, channelName));
    //   case "source":
    //     sourceChannels.forEach(channelName => createSeries(channelName, channelName));
    //   case "key-accounts":
    //     keyAccountChannels.forEach(channelName => createSeries(channelName, channelName));
    //}

    /*--------------------------------------------------------------------------------------*/
    //chart.current = x;

    return () => {
      x.dispose();
    };
  }, [id, data, channels, totals, isYTD]);

  return <div className="chart" id={id}></div>;
};

export default Stack;
